/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description CancelActivePlan Button
 */

import { Button, App } from 'antd';

import useBillingInfo from 'hooks/admin/useBillingInfo';
import { openPlanCancellationMail } from 'utils/admin/subscriptions';
import { MODAL_TYPES } from 'components/widgets/modal';
import { useAppStoreValues } from 'store/app';

/**
 * CancelActivePlan
 *
 */
const CancelActivePlan: React.FC<{ plan: Subscriptions.IActivePlanModel }> = ({ plan }) => {
	const { modal } = App.useApp();
	const { setupInfo, user } = useAppStoreValues();
	const { data: billingInfo, isLoading } = useBillingInfo();

	const showCancelPlanModal = () => {
		modal.confirm({
			...MODAL_TYPES.warning,
			title: 'Cancel Plan',
			width: 560,
			content: (
				<>
					{"You'll be redirected to your email client to contact our support team and request cancellation of your plan."}
					<br />
					{'Do you want to continue?'}
				</>
			),
			okButtonProps: { danger: true },
			okText: 'Continue',
			onOk: () => {
				openPlanCancellationMail(plan, setupInfo.supportEmail, billingInfo?.legal_name, user.displayName);
			},
		});
	};

	return (
		<Button disabled={isLoading} danger color='default' type='text' onClick={showCancelPlanModal}>
			{'Cancel'}
		</Button>
	);
};

export default CancelActivePlan;
